module.exports = __webpack_public_path__ + "static/media/photo-2.56c63537.jpeg";